import { SelectAdapter } from "@soqs/common";
import React from "react";
import { Field } from "react-final-form";

const MastersOfficeSelect = (props) => {
  const { mastersOffices, optionsloading = false, ...rest } = props;
  const required = (value) =>
    value !== null && value !== undefined && value !== ""
      ? undefined
      : "Required";

  return (
    <Field
      required
      fullWidth
      name="mastersOffice"
      label="Master's Office"
      component={SelectAdapter}
      options={mastersOffices}
      loading={optionsloading}
      validate={required}
      subscription={{ touched: true, value: true, error: true }}
      {...rest}
    />
  );
};

export default MastersOfficeSelect;
